import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import '../common-css/Table.css';
import { showTableResponse } from '../common-helpers/commonServices';
import CUET_SettingModal from './CUET_SettingModal';
// import NEET_TestManagementModal from './NEET_TestManagementModal';

const CUET_Settings = () => {
    const childRef = useRef();
    const [subjects, setSubjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(subjects);
    const [loadSubjects, setSubjectLoading] = useState(false);

    // Difficulty settings state
    const [difficultySettings, setDifficultySettings] = useState({ EasyThreshold: 90, ModerateThreshold: 60 });
    const [savingDifficulty, setSavingDifficulty] = useState(false);

    // Fetch difficulty settings
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/cuet/difficulty-settings').then((res) => {
            if (res.data.data) {
                setDifficultySettings(res.data.data);
            }
        }).catch((error) => {
            console.log('Error fetching difficulty settings:', error);
        });
    }, []);

    // Save difficulty settings
    const saveDifficultySettings = () => {
        if (Number(difficultySettings.EasyThreshold) <= Number(difficultySettings.ModerateThreshold)) {
            toast.error('Easy threshold must be greater than Moderate threshold');
            return;
        }
        setSavingDifficulty(true);
        axios.post(BACKEND_SERVER_URL + '/cuet/update-difficulty-settings', difficultySettings).then((res) => {
            toast.success(res.data.message);
        }).catch((error) => {
            toast.error(error.response?.data?.message || 'Error updating settings');
        }).finally(() => setSavingDifficulty(false));
    };

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/cuet/settings').then((res) => {
            setSubjects(res.data.data);
            setChecked(res.data.data);
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects.");
        });
    }, [loadSubjects])
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1)?.keys()]?.slice(1)

    return (
        <>
            <div className="row">
                <div className="col-xl-12">

                    {/* Existing Test Settings Table */}
                    <div className="row">
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">
                                <div className='dataTables_info text-dark'>
                                    Records: {checked.length}
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                <th className=' custom-table-header p-2' style={{ width: "50px" }}>Sl.No.</th>
                                                <th className=' custom-table-header p-2 text-start'>All SUBJECT</th>
                                                <th className=' custom-table-header p-2 text-start'>MANAGE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "50px" }}>
                                                        <h6 className="mb-0 fw-bold fs-5">
                                                            {ind + 1 + firstIndex}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-start ' style={{ border: "1px solid #cccccc" }}>
                                                        <h6 className="mb-0 fw-bold fs-5">
                                                            {item.ExamType === "Section-IA" ? "Language Subjects" : item.ExamType === "Section-II" ? "Domain-Specific Subjects" : item.ExamType === "Section-III" ? "General Aptitude Test" : item.ExamType}
                                                        </h6>
                                                    </td>
                                                    <td className="p-1 text-center" style={{ border: "1px solid #ccc", width: "85px" }}>
                                                        <button onClick={() => childRef.current.openModal(item)} className="btn btn-xs btn-info">Manage</button>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(subjects, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Difficulty Threshold Settings Card */}
                    <div className="card shadow-sm mb-3 mt-3" style={{ height: 'auto' }}>
                        <div className="card-header py-2" style={{ backgroundColor: '#cec0cbff', color: 'white' }}>
                            <h6 className="mb-0 fw-bold">⚙️ Difficulty Level Thresholds (Question-wise Analysis)</h6>
                        </div>
                        <div className="card-body py-3">
                            <div className="row align-items-end g-3">
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold text-success mb-1">Easy (≥ X% correct)</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={difficultySettings.EasyThreshold}
                                            onChange={(e) => setDifficultySettings({ ...difficultySettings, EasyThreshold: e.target.value })}
                                            min="1" max="100"
                                        />
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold text-warning mb-1">Moderate (≥ Y% correct)</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={difficultySettings.ModerateThreshold}
                                            onChange={(e) => setDifficultySettings({ ...difficultySettings, ModerateThreshold: e.target.value })}
                                            min="0" max="99"
                                        />
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold text-danger mb-1">Difficult</label>
                                    <input type="text" className="form-control" value={`< ${difficultySettings.ModerateThreshold}% correct`} disabled />
                                </div>
                                <div className="col-md-3">
                                    <button
                                        className="btn btn-primary w-100 fw-bold"
                                        onClick={saveDifficultySettings}
                                        disabled={savingDifficulty}
                                    >
                                        {savingDifficulty ? 'Saving...' : 'Save Thresholds'}
                                    </button>
                                </div>
                            </div>
                            <div className="mt-2">
                                <small className="text-muted">
                                    <strong>Easy:</strong> ≥{difficultySettings.EasyThreshold}% users marked correct &nbsp;|&nbsp;
                                    <strong>Moderate:</strong> {difficultySettings.ModerateThreshold}% – {difficultySettings.EasyThreshold - 1}% &nbsp;|&nbsp;
                                    <strong>Difficult:</strong> &lt;{difficultySettings.ModerateThreshold}%
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CUET_SettingModal ref={childRef} loadData={loadSubjects} setDataLoading={setSubjectLoading} />
        </>
    )
}

export default CUET_Settings;
